module.exports = [{
      plugin: require('/tmp/3b43711/node_modules/gatsby-plugin-netlify-cms/gatsby-browser.js'),
      options: {"plugins":[],"enableIdentityWidget":false},
    }]
